exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.isOnline[data-v-3724feee] {\n        color: green !important;\n}\n.isOffline[data-v-3724feee] {\n        color: red !important;\n}\n", ""]);

// exports
